import Table from "components/Template/Table";
import React, { useState } from "react";
import Eye from "icons/eye.svg";
import EyeDisabled from "icons/eye-disabled.svg";
import Close from "icons/close-circle.svg";
import CloseDisabled from "icons/confirm-circle-green.svg";
import dateformat from "dateformat";
import ButtonIcon from "components/ButtonIcon";
import { useHistory } from "react-router-dom";
import Loading from "components/Loading";
import { ToastContainer } from "react-toastify";
import ChangeStatusModal from "./ChangeStatusModal";
import Button from "components/Button";

type Props = {
  isLoading: boolean;
  listChannel: any;
  groupId: string;
  groupName: string;
  rechargeChannels: () => void;
};

const TableChannels: React.FC<Props> = ({
  listChannel,
  groupId,
  groupName,
  isLoading,
  rechargeChannels,
}): JSX.Element => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [show, setShow] = useState(false);
  const [channelId, setChannelId] = useState("");

  if (isLoading) {
    return (
      <div className="flex flex-row w-full">
        <div className="relative my-auto mx-auto">
          <div
            style={{ borderTopColor: "transparent" }}
            className="w-10 h-10 border-4 border-bt-black border-solid rounded-full animate-spin"
          />
        </div>
      </div>
    );
  }

  return (
    <>
      <Loading loading={loading} />
      <ChangeStatusModal
        channelId={channelId}
        groupId={groupId}
        setLoading={setLoading}
        active={active}
        setChannelId={setChannelId}
        rechargeChannels={rechargeChannels}
        show={show}
        setShow={setShow}
      />

      {listChannel?.length > 0 ? (
        <Table
          childrenThead={
            <tr className="font-sora">
              <td className="px-7">Channel</td>
              <td>Users</td>
              <td>Permission</td>
              <td>Created</td>
              <td>Reports</td>
              <td>View</td>
              <td>Status</td>
            </tr>
          }
          childrenTbody={
            <>
              {listChannel.length > 0 &&
                listChannel.map((channel: any, i: number) => (
                  <tr
                    className="font-sora text-base"
                    style={{
                      background:
                        channel.disabled === false ? "#FFFFFF" : "#E7E9EF",
                      color: channel.disabled === false ? "#2A2B31" : "#707070",
                    }}
                    key={i}
                  >
                    <td className="px-7 py-7">Channel {i + 1}</td>
                    <td>
                      {channel.members.map((member: any) => (
                        <p className="my-2" key={member.user_id}>
                          {member.user.name.split(" ")[0]}
                        </p>
                      ))}
                    </td>
                    <td className="py-7">
                      {channel.members.map((member: any) => (
                        <p className="my-2" key={member.user_id}>
                          {member.role}
                        </p>
                      ))}
                    </td>
                    <td>{dateformat(channel.created, "mm.dd.yyyy")}</td>
                    <td className="w-[120px] relative">
                      {channel.hasReports && (
                        <Button
                          className="font-nunito text-white left-[21px] inset-0 absolute  rounded-full border-none w-7 h-7 items-center bg-bt-red-alert"
                          onClick={() => {}}
                          label="!"
                        />
                      )}
                    </td>
                    <td style={{ width: "70px" }}>
                      {channel.disabled === false ? (
                        <ButtonIcon
                          icon={Eye}
                          status={true}
                          onClick={() => {
                            history.push(
                              `/manage-families/${groupId}/channel/${channel.id}`,
                              { name: groupName, channel: i + 1 }
                            );
                          }}
                        />
                      ) : (
                        <ButtonIcon
                          icon={EyeDisabled}
                          status={false}
                          onClick={() => {}}
                        />
                      )}
                    </td>
                    <td style={{ width: "70px" }}>
                      {channel.disabled === false ? (
                        <ButtonIcon
                          icon={Close}
                          status={true}
                          onClick={() => {
                            setActive(false);
                            setChannelId(channel.id);
                            setShow(true);
                          }}
                        />
                      ) : (
                        <ButtonIcon
                          icon={CloseDisabled}
                          status={true}
                          onClick={() => {
                            setActive(true);
                            setChannelId(channel.id);
                            setShow(true);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                ))}
            </>
          }
        />
      ) : (
        <div className="flex flex-row justify-center items-center">
          <span
            className="font-nunito text-lg"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#4A4A4A",
            }}
          >
            No channel data
          </span>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default TableChannels;
